import React, { useState } from "react";
import { connect } from "react-redux";

import "react-phone-input-2/lib/plain.css";

import { adminLogin } from "../Actions";

import salcitLogo from "../Assets/images/Swaasa.png";
import { Link } from "react-router-dom";

const LoginForm = (props) => {
  console.log(props)
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);

  const onLogin = (e) => {
    e.preventDefault();

    setError(false);
    if (
      !/^[A-Za-z0-9]+([._%+-]{0,1}[A-Za-z0-9]+)*@[A-Za-z0-9-]+(\.[A-Za-z]{2,})*$/.test(
        email
      )
    ) {
      setError(true);
    } else if (password.length === 0) {
      setError(true);
    } else if (!error) {
      let formData = new FormData();
      formData.append("loginId", email);
      formData.append("password", password);
      props.adminLogin(formData, email);
    }
  };

  return (
    <form className="auth__form" onSubmit={onLogin}>
      <div className="auth__input">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email"
        />
        {error &&
          !/^[A-Za-z0-9]+([._%+-]{0,1}[A-Za-z0-9]+)*@[A-Za-z0-9-]+(\.[A-Za-z]{2,})*$/.test(
            email
          ) && <p>Enter a valid email</p>}
      </div>
      <div className="auth__input">
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
        />
        {error && password.length === 0 && <p>Password cannot be blank</p>}
      </div>
      <button type="submit" className="auth__form__btn auth__form__btn--login">
        Login
      </button>
      <div>
        <Link to="/">
          <button className="auth__form__btn auth__form__btn--login adminbutton">
            Back
          </button>
        </Link>
      </div>
    </form>
  );
};

const ConnectedLoginForm = connect(null, { adminLogin })(LoginForm);

const Auth = () => {
  const [tab, setTab] = useState("login");

  return (
    <div className="auth">
      <div className="auth__content">
        <div className="auth__logo">
          <img src={salcitLogo} alt="logo" />
        </div>

        <div className="auth__tabs">
          <div
            className="auth__tab"
            onClick={() => setTab("login")}
            style={
              tab === "login" ? { borderBottom: "0.2rem solid #1d1602" } : {}
            }
          >
            <p>Admin Login</p>
          </div>
        </div>
        {(() => {
          switch (tab) {
            case "login":
              return <ConnectedLoginForm />;
            default:
              break;
          }
        })()}
      </div>
    </div>
  );
};

export default Auth;
